import { call, put, takeLatest } from "redux-saga/effects";
import { showAlert } from "../../alertSlice";
import { getBasicAutomationsApi, saveBasicAutomationsApi } from "../../../api/apiLists/workflow";
import {
  fetchBasicAutomationsFailure,
  fetchBasicAutomationsRequest,
  fetchBasicAutomationsStart,
  fetchBasicAutomationsSuccess,
  saveBasicAutomationsFailure,
  saveBasicAutomationsRequest,
  saveBasicAutomationsStart,
  saveBasicAutomationsSuccess
} from "../../slices/workflow";
import { callWorkflowApi, requireWhatsAppModuleAccess } from "./workflowSagaHelper";

function* handleFetchBasicAutomations(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  try {
    yield put(fetchBasicAutomationsStart());

    const req = action.payload || { operation: "GET_BASIC_AUTOMATIONS", payload: {} };
    const res = yield callWorkflowApi(getBasicAutomationsApi, req);

    if (res?.status) {
      const rules = res?.data?.rules ?? res?.data?.payload?.rules ?? null;
      yield put(fetchBasicAutomationsSuccess(rules));
      return;
    }

    yield put(fetchBasicAutomationsFailure(res?.errMsg || "Failed to load basic automations"));
  } catch (error) {
    yield put(fetchBasicAutomationsFailure(error.message || "Failed to load basic automations"));
  }
}

function* handleSaveBasicAutomations(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  try {
    yield put(saveBasicAutomationsStart());

    const req = action.payload || { operation: "SAVE_BASIC_AUTOMATIONS", payload: { rules: [] } };
    const res = yield callWorkflowApi(saveBasicAutomationsApi, req);

    if (res?.status) {
      yield put(saveBasicAutomationsSuccess());
      yield put(showAlert({ message: "Basic automations saved successfully.", type: "success" }));
      yield put(fetchBasicAutomationsRequest({ operation: "GET_BASIC_AUTOMATIONS", payload: {} }));
      return;
    }

    const errMsg = res?.errMsg || "Failed to save basic automations";
    yield put(saveBasicAutomationsFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  } catch (error) {
    const errMsg = error.message || "Failed to save basic automations";
    yield put(saveBasicAutomationsFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  }
}

export default function* basicAutomationsSaga() {
  yield takeLatest(fetchBasicAutomationsRequest.type, handleFetchBasicAutomations);
  yield takeLatest(saveBasicAutomationsRequest.type, handleSaveBasicAutomations);
}
